import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('tx') || searchParams.get('transaction_id') || searchParams.get('reference');

  useEffect(() => {
    const params = new URLSearchParams();
    if (transactionId) params.set('tx', transactionId);
    params.set('status', 'success');
    navigate(`/pay?${params.toString()}`, { replace: true });
  }, [navigate, transactionId]);

  return null;
}

export default PaymentSuccess;
